module.exports = __webpack_public_path__ + "6c7a6dddb981acafc3947f7bc4a3b232.pdf";